import React, { memo } from 'react';
import BaseReferenceDisplay from '../../../reference/ReferenceDisplay';

export const ReferenceDisplay = memo(function ReferenceDisplay({
  reference,
  field,
  children,
}) {
  if (field?.options?.modelId === 'file/file') {
    return null;
  }

  return (
    <BaseReferenceDisplay
      reference={reference}
      multiModel={field?.options?.multiModel}
      separator={field?.options?.separator}
    >
      {children}
    </BaseReferenceDisplay>
  );
});
